export const FEATURED = 'featured';
export const HIGH_TO_LOW = 'price-desc';
export const LOW_TO_HIGH = 'price-asc';
export const RELEVANCE = 'relevance';
export const TRENDING = 'trending';

export const sortOptionDetails = {
  [FEATURED]: {
    label: 'Featured',
    value: {
      property: 'position',
      direction: 'asc',
    },
  },
  [HIGH_TO_LOW]: {
    label: 'Price (high to low)',
    value: {
      property: 'selectedOfferPrice',
      direction: 'desc',
    },
  },
  [LOW_TO_HIGH]: {
    label: 'Price (low to high)',
    value: {
      property: 'selectedOfferPrice',
      direction: 'asc',
    },
  },
  [RELEVANCE]: {
    label: 'Relevance',
    value: null,
  },
  [TRENDING]: {
    label: 'Trending',
    value: null,
  },
};

export const getSortOptionDetails = option => sortOptionDetails[option];
